import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_API_URL;

export const post_product = createAsyncThunk(
  "product/post_product",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/product/new`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("product Not create");
    }
  }
);

export const productImagePost = createAsyncThunk(
  "product/productImagePost",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
        maxBodyLength: Infinity,
      };
      const url = `${Baseurl}/api/v1/product/uploade-images`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("image Icon Not create");
    }
  }
);

export const validateSlugUrl = createAsyncThunk(
  "product/validateSlugUrl",
  async (slugurl, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/product/verify-slugurl/${slugurl}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);



const initialState = {
  product_all: JSON.parse(localStorage.getItem("product_all"))
    ? JSON.parse(localStorage.getItem("product_all")).sort((a, b) =>
        a.createdAt > b.createdAt ? 1 : -1
      )
    : [],
  product_allLoading: true,
  isproduct_allAvailable: localStorage.getItem("product_all") ? true : false,
  thumbnail: "",
  productImageLoading: true,
  current_category: JSON.parse(localStorage.getItem("current_category"))
    ? JSON.parse(localStorage.getItem("current_category"))
    : "",
  current_menu: JSON.parse(localStorage.getItem("current_menu"))
    ? JSON.parse(localStorage.getItem("current_menu"))
    : "",
};

const ProductSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    updateImages(state, action) {
      state.thumbnail = action.payload.thumbnail;
      state.productImageLoading = true;
    },
    updatecurrentCatMenu(state, action) {
      state.current_category = action.payload.current_category;
      state.current_menu = action.payload.current_menu;
      localStorage.setItem(
        "current_category",
        JSON.stringify(state.current_category)
      );
      localStorage.setItem("current_menu", JSON.stringify(state.current_menu));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(post_product.pending, (state) => {
        state.product_allLoading = true;
      })
      .addCase(post_product.fulfilled, (state, action) => {
        state.product_all = [...state.product_all, action.payload.product];
        state.product_all = state.product_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );

        localStorage.setItem("product_all", JSON.stringify(state.product_all));
        state.product_allLoading = false;
        state.isproduct_allAvailable = true;
      })
      .addCase(post_product.rejected, (state) => {
        state.product_allLoading = true;
      });

    builder
      .addCase(productImagePost.pending, (state) => {
        state.productImageLoading = true;
      })
      .addCase(productImagePost.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.thumbnail = action.payload.image;
        }
        state.productImageLoading = true;
      })
      .addCase(productImagePost.rejected, (state) => {
        state.productImageLoading = true;
      });
  },
});

export const { updateImages, updatecurrentCatMenu } = ProductSlice.actions;
export const authActions = ProductSlice.actions;
export default ProductSlice.reducer;
